module.exports = __webpack_public_path__ + "img/87.11923fd4.png";